
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: '',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Array,
    default: () => ({}),
    required: true
  })
  all!: any;

  @Prop({
    type: Object,
    default: () => {}
  })
  selectDoor!: any;
  // company_introduction 公司介绍  picture_ad 图片广告   company_notice 公司公告   picture_navigation 图文导航    video_card 视频卡片    title_text 标题文本   article_text 正文文本

  private defaultadvertImg = require('@/assets/images/door-advert-default.png')
  private defaultVideoImg = require('@/assets/images/door-video-default.png')
  private allType: any = []

  @Watch('selectDoor', {
    deep: true,
    immediate: true
  })
  handleChangePropsType() {
    this.allType = this.all
    if (this.selectDoor && this.selectDoor.key) {
      this.$emit('doorEditType', this.selectDoor);
    }
  }

  private linkImgSrc(value: any) {
    switch (value) {
      case 'scan_report':
        value = require('@/assets/images/door-nav-scan.png');
        break;
      case 'order_list':
        value = require('@/assets/images/door-nav-order.png');
        break;
      case 'report_order':
        value = require('@/assets/images/door-nav-create.png');
        break;
      case 'unconfirmed_order':
        value = require('@/assets/images/door-nav-unconfirmed.png');
        break;
      case 'unevaluated_order':
        value = require('@/assets/images/door-nav-unevaluated.png');
        break;
      case 'service_hotline':
        value = require('@/assets/images/door-nav-hotline.png');
        break;
      case 'device_list':
        value = require('@/assets/images/door-nav-device.png');
        break;
      case 'company_notice':
        value = require('@/assets/images/door-nav-notice.png');
        break;
      case 'install_apply':
        value = require('@/assets/images/door-nav-install-apply.png');
        break;
      default:
        value = require('@/assets/images/door-nav-default.png');
        break;
    }
    return value;
  }
  private prevHandle(index: any) {
    if (index === 0) {
      return false;
    }
    let cut = this.allType[index];
    this.allType.splice(index, 1);
    this.allType.splice(index - 1, 0, cut);
  }
  private nextHandle(index: any) {
    if (index === this.allType.length - 1) {
      return false
    }
    let cut = this.allType[index];
    this.allType.splice(index, 1);
    this.allType.splice(index + 1, 0, cut);
  }
  private delHandle(index: any, val:any) {
    this.allType.splice(index, 1);
    this.$emit('delDoorItem', index, val);
  }
  private selectedHandle(val: any) {
    this.$emit('doorEditType', val)
  }

  private isPlayVideo = false
  private playVideoHandle() {
    this.isPlayVideo = true
  }
}
